import Form from './form';

class MailingListForm extends Form {

  constructor(form) {
    super(form);

    this.elements = {
      ...this.elements,
      submit: form.querySelector('[type="submit"]'),
      content: form.querySelector('.js-mailing-list-content'),
      error: form.querySelector('.js-mailing-list-error'),
      resultText: form.querySelector('.js-form-mailing-list__result')
    };
    this.elements.error.style.display = 'none';
  }

  /**
   * Send form via ajax.
   */
  submit() {
    this.elements.submit.disabled = true;
    this.elements.submit.classList.add('loading');
    this.elements.form.classList.add('loading');
    this.elements.error.style.display = 'none';

    fetch(this.elements.form.dataset.ajaxUrl, {
      method: 'POST',
      body: new FormData(this.elements.form),
    })
      .then(response => response.json())
      .then(response => {
        // Refresh all tokens
        if (response.token) {
          document.querySelectorAll('[name="stage_token"], [name="token"]').forEach(token => {
            token.value = response.token;
          });
        }

        if (response.status === 'success') {
          const heading = document.createElement('h3');
          heading.innerText = response.text || '';
          this.elements.resultText.appendChild(heading);
          this.elements.content.style.display = 'none';
        }
        else {
          this.elements.error.innerHTML = response.text || '';
          this.elements.error.style.display = 'block';
        }
      })
      .catch(error => {})
      .finally(() => {
        this.elements.submit.disabled = false;
        this.elements.submit.classList.remove('loading');
        this.elements.form.classList.remove('loading');
      });
  }
}

export default MailingListForm;
